import React, { MouseEvent, useEffect, useRef } from 'react'
import xIcon from 'icons/Close.svg'

import { isMobile } from '../../helper/isMobile'

import {
  CloseIcon,
  CloseIconContainer,
  GreetingContainer,
  GreetingText,
  GreetingTextContainer
} from './GreetingPopup.style'

interface Props {
  dataTest?: string
  handleClosePopup: (e: MouseEvent<HTMLElement>) => void
  handleSubmitPopup: () => void
  text: string
}

const GreetingPopup: React.FC<Props> = ({
  dataTest,
  handleClosePopup,
  handleSubmitPopup,
  text
}) => {
  const isMobileDevice = isMobile()
  const greetingTextRef = useRef(null)

  useEffect(() => {
    greetingTextRef.current.focus()
  }, [])

  return (
    <GreetingContainer
      data-test={dataTest}
    >
      <CloseIconContainer
        onClick={handleClosePopup}
        isMobileDevice={isMobileDevice}
      >
        <CloseIcon src={xIcon} />
      </CloseIconContainer>
      <GreetingTextContainer
        onClick={handleSubmitPopup}
      >
        <GreetingText ref={greetingTextRef}>
          {text}
        </GreetingText>
      </GreetingTextContainer>
    </GreetingContainer>
  )
}

export default GreetingPopup
